// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"90c38bfe","505":"02f9b1f9","818":"e32bf201","953":"6e54ee9e"}[chunkId] + ".chunk.js";
};